import { render, staticRenderFns } from "./FeeFormula.vue?vue&type=template&id=579b4191&scoped=true&"
import script from "./FeeFormula.vue?vue&type=script&lang=js&"
export * from "./FeeFormula.vue?vue&type=script&lang=js&"
import style0 from "./FeeFormula.vue?vue&type=style&index=0&id=579b4191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b4191",
  null
  
)

component.options.__file = "FeeFormula.vue"
export default component.exports